'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { usePathname } from 'next/navigation';

// lib files
import { StationData } from '@/lib/types/api/stations-data';

// components
import NetworkProfile from '@/components/Network/NetworkProfile';
import NetworkMyListShows from '@/components/Network/NetworkMyListShows';
import NetworkMyListVideos from '@/components/Network/NetworkMyListVideos';
import NetworkMyListViewingHistory from '@/components/Network/NetworkMyListViewingHistory'
import NetworkContinueWatching from '@/components/Network/NetworkContinueWatching';
import NetworkCountry from '@/components/Network/NetworkCountry';
import NetworkFavoriteStation from '@/components/Network/NetworkFavoriteStation';
import NetworkLocalization from '@/components/Network/NetworkLocalization';
import NetworkStation from '@/components/Network/NetworkStation';
import NetworkViewingHistory from '@/components/Network/NetworkViewingHistory';

type NetworkComponentMap = {
  [key: string]: React.ComponentType;
};

// This list will need to be updated if other personalized data is needed in the future
const pathnameToNetworkMap: NetworkComponentMap = {
  '/my-list/viewing-history/': () => <NetworkMyListViewingHistory />
}

interface NetworkManagerProps {
  stationData: StationData;
  isSVP: boolean;
  pollRate: number;
}

const NetworkManager = (props: NetworkManagerProps) => {
  const { stationData, isSVP, pollRate } = props;
  const pathname = usePathname()

  const PageSpecificNetworkComponent = pathnameToNetworkMap[pathname]
  const hasComponentToRender = PageSpecificNetworkComponent !== undefined

  return (
    <>
      <NetworkProfile pollRate={pollRate} data-sentry-element="NetworkProfile" data-sentry-source-file="NetworkManager.tsx" />
      <NetworkViewingHistory data-sentry-element="NetworkViewingHistory" data-sentry-source-file="NetworkManager.tsx" />
      <NetworkMyListShows data-sentry-element="NetworkMyListShows" data-sentry-source-file="NetworkManager.tsx" />
      <NetworkMyListVideos data-sentry-element="NetworkMyListVideos" data-sentry-source-file="NetworkManager.tsx" />
      <NetworkContinueWatching data-sentry-element="NetworkContinueWatching" data-sentry-source-file="NetworkManager.tsx" />
      <NetworkCountry data-sentry-element="NetworkCountry" data-sentry-source-file="NetworkManager.tsx" />
      { !isSVP && (
        <>
          <NetworkLocalization initialStationId={stationData?.id} />
          <NetworkFavoriteStation />
        </>
      )}
      <NetworkStation stationData={stationData} data-sentry-element="NetworkStation" data-sentry-source-file="NetworkManager.tsx" />
      { hasComponentToRender && (
        <PageSpecificNetworkComponent/>
      )}
    </>
  )
}

export default NetworkManager
